export const truncateText = (text, limit) => {
    if (typeof text !== 'string') return '';

    const result = text.substring(0, limit);
    const lastWitheSpaceIndex = result.lastIndexOf(" ");
    return result.substring(0, lastWitheSpaceIndex) + ' ...';
}